import { Fragment } from "react";
import Container from "react-bootstrap/Container";
import { Helmet } from 'react-helmet';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import BannerCotizador from "../../images/catalogo/catalogo-banner.webp";

function BannerVehiculos() {
  return (
    <Fragment>
      <Container fluid={true} className="catalogo-banner">
        <Row>
          <Col md={12} className="px-0">
            <Helmet>
              <link rel="preload" href={BannerCotizador} as="image" />
            </Helmet>
            <Card>
              <img
                src={BannerCotizador}
                alt="Hyundai Banner"
                className="banner-vehiculos"
                //fetchpriority="high"
              />
              {/*
              <Card.ImgOverlay className="d-flex">
                <Card.Title className="bg-banner-vehiculos d-flex align-items-center">
                  <div className="mx-auto my-auto w-100">
                    <h1 className="modelo-etiqueta">Vehículos disponibles</h1>
                  </div>
                </Card.Title>
              </Card.ImgOverlay>
              */}
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}
export default BannerVehiculos;